<template>
  <v-layout column class="section-pillars">
		<v-layout justify-center>
			<router-link to="/">
				<img v-if="windowSize.x < 1024" src="https://web-apprunn.s3-sa-east-1.amazonaws.com/logo-apprunn-responsive.svg" alt="" class="icon-logo-responsive">
			</router-link>
		</v-layout>
    <v-flex justify-center class="grid-arrow">
      <img src="https://japi-static.s3.amazonaws.com/japi-sales-error/arrows.png" alt="" class="icons-arrow">
    </v-flex>
    <v-layout column class="content-text-pillars">
      <v-flex class="title-section-pillars" :class="windowSize.x < 1024 ? 'text-xs-center' : 'text-xs-left'" >NUESTRO ÉXITO SE DEBE A <span class="number-pillars">3 PILARES</span> IMPORTANTES EN NUESTRO DÍA A DÍA</v-flex>
      <v-flex class="text-description" :class="windowSize.x < 1024 ? 'text-xs-center' : 'text-xs-left'">Somos innovadores por excelencia, pero esta excelencia  se sostiene
        en 3 pilares infalibles que nos permiten crear productos exitosos.</v-flex>
    </v-layout>
    <v-flex justify-center class="grid-arrow">
      <img src="https://japi-static.s3.amazonaws.com/japi-sales-error/arrows.png" alt="" class="icons-arrow">
    </v-flex>
  </v-layout>
</template>

<script>
export default {
	name: 'section-pillars',
	props: {
		windowSize: {
			type: Object,
			default: () => {},
		},
	},
};
</script>

<style lang="scss" scoped>
.section-pillars {
  background-color: map-get($colors, white);
  padding-top: 140px;
	width: 100%;

	@media (max-width: 1024px) {
		padding: 59px 37px;
	}
}

.grid-arrow {
  display: flex;
}

.text-description {
  color: map-get($colors, gray-regular);
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 24px;

  @media (max-width: 1024px) {
    font-size: 18px;
  }
}

.number-pillars {
  color: map-get($colors, blue-regular);
  font-size: 30px;
	font-family: 'Lato', sans-serif;
  font-weight: 900;
	
	@media (max-width: 1024px) {
		font-size: 24px;
	}
}

.title-section-pillars {
  color: map-get($colors, base);
  font-family: 'Lato', sans-serif;
  font-weight: 900;
  font-size: 24px;
  line-height: 1.67;
  margin-bottom: 30px;

  @media (max-width: 1024px) {
    font-size: 18px;
  }
}

.content-text-pillars {
  margin: 90px auto;
	max-width: 455px;
	
	@media (max-width: 1024px) {
		margin: 25px auto;
	}
}

.icons-arrow {
	@media (max-width: 1024px) {
		width: 282px;
	}
}

.icon-logo-responsive {
	margin-bottom: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/pillars/section-pillars.vue